<template>
    <div class="dx-fieldset">
        <div class="dx-field">
            <!-- <div class="dx-field-label">Тема изменений</div> -->
            <div class="dx-field-value">
                <DxDropDownBox v-model:value="treeBoxValue" v-model:opened="isTreeBoxOpened"
                    :input-attr="{ 'aria-label': 'Owner' }" :show-clear-button="true"
                    :data-source="store.state.historyData.tabGroups" value-expr="id" display-expr="name"
                    placeholder="Тематика изменений" @value-changed="syncTreeViewSelection($event)">
                    <template #content="{ }">
                        <DxTreeView :data-source="store.state.historyData.tabGroups" :select-by-click="true"
                            data-structure="plain" key-expr="id" parent-id-expr="groupId" selection-mode="single"
                            display-expr="name" @content-ready="treeViewContentReady($event)"
                            @item-selection-changed="treeViewItemSelectionChanged($event)"
                            @item-click="onTreeItemClick($event)" />
                    </template>
                </DxDropDownBox>
            </div>
        </div>
    </div>
</template>

<script setup>
import store from '@/store';
import { ref } from 'vue';

import DxDropDownBox from 'devextreme-vue/drop-down-box';
import DxTreeView from 'devextreme-vue/tree-view';


const treeBoxValue = ref(null);
const isTreeBoxOpened = ref(false);

const loadData = async () => {
};
loadData();

let treeView = null;

function treeViewContentReady({ component }) {
    treeView = component;
    syncTreeViewSelection();
}

function syncTreeViewSelection() {
    treeView?.unselectAll();

    if (treeBoxValue.value) {
        treeView?.selectItem(treeBoxValue.value);
    }
}

function treeViewItemSelectionChanged(e) {
    treeBoxValue.value = e.component.getSelectedNodeKeys();
}

function onTreeItemClick() {
    isTreeBoxOpened.value = false;
}

</script>